import React from 'react'
import './Blogs.css'
import BlogWidget from './BlogWidget/BlogWidget'
import Page from "../../Page/Page";
import SeoHelmet from '../../../Components/SeoHelmet/SeoHelmet';

const Blogs = () => {
    return (
        <Page>
            <SeoHelmet title="Blog - Elite Partyz App" description="Read the latest news, tips, and updates from Elite Partyz. " keywords="Party, Elite Party, Event, Event manager, blogs" canonicalLink="/blog" />
            <div className="blogs-page">
                <BlogWidget />
            </div>
        </Page>
    )
}

export default Blogs
